export default __webpack_public_path__ + "static/DSC_0061-5c7331990bac4c2586270cdbc36063d1.jpg";